import { useContext } from "react";
import { AppContext } from "../App";
import { getCurrentYear } from "../Helpers";
import { serviceCategories } from "./ServicesContent";
import logo from "../assets/logo.png";

export default function Footer() {
  const appContext = useContext(AppContext);

  return (
    <footer className="vex-footer" data-aos="fade-up">
      <div className="container">
        <div className="row g-4 vex-footer-grid">
          <div className="col-lg-4">
            <div className="vex-footer-brand">
              <img src={logo} alt="Vex Traders" />
            </div>
            <h3>
              Supplying and distributing products that keep organizations moving.
            </h3>
            <p className="vex-footer-copy">
              Reliable products, responsive service, and structured delivery across
              multiple industries.
            </p>
          </div>

          <div className="col-sm-6 col-lg-2">
            <p className="vex-footer-label">Navigation</p>
            <button type="button" onClick={() => appContext.navTo({ item: "home" })}>
              Home
            </button>
            <button type="button" onClick={() => appContext.navTo({ item: "about_us" })}>
              About
            </button>
            <button type="button" onClick={() => appContext.navTo({ item: "contact_us" })}>
              Contact
            </button>
            <button type="button" onClick={() => appContext.navTo({ item: "services" })}>
              Services
            </button>
          </div>

          <div className="col-sm-6 col-lg-3">
            <p className="vex-footer-label">Categories</p>
            {serviceCategories.map((service) => (
              <button
                key={service.slug}
                type="button"
                onClick={() =>
                  appContext.navTo({ item: "services", subItem: service.slug })
                }
              >
                {service.title}
              </button>
            ))}
          </div>

          <div className="col-lg-3">
            <p className="vex-footer-label">Contact</p>
            <a href="tel:+255767105804">+255 767 105 804</a>
            <a href="mailto:supply@vex-traders.co.tz">supply@vex-traders.co.tz</a>
            <p>Near Mlimani City, Dar Es Salaam, Tanzania</p>
          </div>
        </div>

        <div className="vex-footer-bottom">
          <p>&copy; Vex {getCurrentYear()}</p>
          <p>
            Website created by{" "}
            <a
              href="https://werenium.com"
              target="_blank"
              rel="noreferrer"
              className="vex-footer-credit-link"
            >
              Werenium Technologies
            </a>
          </p>
        </div>
      </div>

      <style>{`
        .vex-footer {
          position: relative;
          background: radial-gradient(circle at top, #0f172a, #020617);
          color: #e2e8f0;
          padding: 90px 0 40px;
          overflow: hidden;
        }

        .vex-footer::before {
          content: "";
          position: absolute;
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, rgba(91,140,255,0.15), transparent 70%);
          top: -200px;
          right: -200px;
          z-index: 0;
        }

        .vex-footer .container {
          position: relative;
          z-index: 1;
        }

        .vex-footer-brand img {
          width: 140px;
          margin-bottom: 20px;
          filter: brightness(1.2);
        }

        .vex-footer h3 {
          font-size: 20px;
          line-height: 1.5;
          margin-bottom: 15px;
          color: white;
        }

        .vex-footer-copy {
          color: #94a3b8;
          font-size: 14px;
          max-width: 320px;
        }

        .vex-footer-label {
          font-size: 12px;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          color: #5b8cff;
          margin-bottom: 15px;
        }

        .vex-footer button,
        .vex-footer a {
          display: block;
          background: none;
          border: none;
          padding: 0;
          margin-bottom: 10px;
          color: #cbd5f5;
          font-size: 14px;
          cursor: pointer;
          text-align: left;
          position: relative;
          transition: all 0.25s ease;
        }

        .vex-footer button::after,
        .vex-footer a::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -2px;
          width: 0%;
          height: 1px;
          background: #00d4ff;
          transition: width 0.3s ease;
        }

        .vex-footer button:hover,
        .vex-footer a:hover {
          color: #00d4ff;
          transform: translateX(4px);
        }

        .vex-footer button:hover::after,
        .vex-footer a:hover::after {
          width: 100%;
        }

        .vex-footer p {
          font-size: 14px;
          color: #94a3b8;
        }

        .vex-footer-grid > div {
          padding: 20px;
          border-radius: 14px;
          background: rgba(255,255,255,0.02);
          backdrop-filter: blur(6px);
          transition: all 0.3s ease;
        }

        .vex-footer-grid > div:hover {
          background: rgba(255,255,255,0.05);
          transform: translateY(-4px);
        }

        .vex-footer-bottom {
          margin-top: 50px;
          padding-top: 20px;
          border-top: 1px solid rgba(255,255,255,0.08);
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 10px;
        }

        .vex-footer-bottom p {
          font-size: 13px;
          color: #64748b;
        }

        .vex-footer-credit-link {
          color: #5b8cff;
          text-decoration: none;
          position: relative;
        }

        .vex-footer-credit-link:hover {
          color: #00d4ff;
        }

        @media (max-width: 768px) {
          .vex-footer {
            padding: 70px 0 30px;
          }

          .vex-footer h3 {
            font-size: 18px;
          }

          .vex-footer-grid > div {
            padding: 15px;
          }
        }
      `}</style>
    </footer>
  );
}
